import { render, staticRenderFns } from "./OnlineReservationScheduleHelp.vue?vue&type=template&id=23690f55&scoped=true&lang=pug"
import script from "./OnlineReservationScheduleHelp.vue?vue&type=script&lang=ts"
export * from "./OnlineReservationScheduleHelp.vue?vue&type=script&lang=ts"
import style0 from "./OnlineReservationScheduleHelp.vue?vue&type=style&index=0&id=23690f55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23690f55",
  null
  
)

export default component.exports